import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';

export type InitialState = {
    houses: HouseSearchListItem[];
    total: number;
    groupedLocations: GroupedLocation[];
    calculateTouristTaxHouseIds?: number[];
};

export default class HouseSearchListItems extends AbstractSubject {
    static #instance: HouseSearchListItems | null = null;

    public static getInstance(
        initialState: InitialState = {
            houses: [],
            total: 0,
            groupedLocations: [],
            calculateTouristTaxHouseIds: []
        }
    ): HouseSearchListItems {
        if (HouseSearchListItems.#instance === null) {
            HouseSearchListItems.#instance = new HouseSearchListItems();

            HouseSearchListItems.#instance.#houses = initialState.houses;
            HouseSearchListItems.#instance.#total = initialState.total;
            HouseSearchListItems.#instance.#groupedLocations = initialState.groupedLocations;
            HouseSearchListItems.#instance.#calculateTouristTaxHouseIds =
                initialState.calculateTouristTaxHouseIds ?? [];
        }

        return HouseSearchListItems.#instance;
    }

    #houses: HouseSearchListItem[] = [];

    get houses(): HouseSearchListItem[] {
        return this.#houses;
    }

    getHouse(id: number): HouseSearchListItem | null {
        return this.#houses.find((house) => house.id === id) || null;
    }

    #total = 0;

    get total(): number {
        return this.#total;
    }

    #groupedLocations: GroupedLocation[] = [];

    #calculateTouristTaxHouseIds: number[] = [];

    #userHasPeriodSelected: boolean = false;

    get groupedLocations(): GroupedLocation[] {
        return this.#groupedLocations;
    }

    get userHasPeriodSelected(): boolean {
        return this.#userHasPeriodSelected;
    }

    get calculateTouristTaxHouseIds(): number[] {
        return this.#calculateTouristTaxHouseIds;
    }

    public setResults(
        houses: HouseSearchListItem[],
        total: number,
        groupedLocations: GroupedLocation[] = [],
        userHasPeriodSelected: boolean = false,
        calculateTouristTaxHouseIds: number[] = []
    ): void {
        this.#houses = houses;
        this.#total = total;
        this.#groupedLocations = groupedLocations;
        this.#userHasPeriodSelected = userHasPeriodSelected;
        this.#calculateTouristTaxHouseIds = calculateTouristTaxHouseIds;
        this.notify();
    }
}
